import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer id="footer" className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-title-container">
              <img
                src="/theinnerjourneylogo.svg"
                alt="The Inner Journey"
                className="footer-logo"
              />
              <h3 className="footer-title">The Inner Journey</h3>
            </div>
            <p className="footer-subtitle">with Arushi Suri</p>
            <p className="footer-role">Counselling Psychologist</p>
          </div>
          <div className="footer-contact">
            <h4 className="contact-heading">Contact</h4>
            <p className="contact-item">
              <svg
                className="contact-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
              </svg>
              <a href="tel:+919625998829" className="contact-link">
                +91 9625998829
              </a>
            </p>
            <p className="contact-item">
              <svg
                className="contact-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              <a
                href="mailto:therapistarushisuri@gmail.com"
                className="contact-link"
              >
                therapistarushisuri@gmail.com
              </a>
            </p>
            <p className="contact-item">
              <svg
                className="contact-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              <a
                href="mailto:arushisuri@theinnerjourney.in"
                className="contact-link"
              >
                arushisuri@theinnerjourney.in
              </a>
            </p>
            {/* <p className="contact-item">
              <strong>Location:</strong> Lajpat Nagar
            </p> */}
            <p className="contact-item">
              <svg
                className="contact-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              <a
                href="https://instagram.com/the_innerjourney_"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                the_innerjourney_
              </a>
            </p>
          </div>
        </div>
        <div className="footer-note">
          <p className="disclaimer">
            <strong>
              Note: <br />
              These services are not for crisis intervention or emergency care.​
              For any MH emergencies, you can contact: <br />
              National Mental Health Helpline 1800-599-0019 <br />
              Tele MANAS 1-800-891-4416 <br />
              Fortis Helpline 8376804102
            </strong>
          </p>
        </div>
        <div className="footer-copyright">
          <p>
            &copy; {new Date().getFullYear()} The Inner Journey. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
